module.exports = __webpack_public_path__ + "static/20180913_193058_optimized-a7def98ed2eb76c24bbcc8786bf71125.jpg";